export default {
    letSignYouIn: `系统登入`,
    pleaseProvideYourUsernameAndPassword: '请输入登录账号密码',
    username: '账号',
    password: '密码',
    login: '登录',
    // Sign Up
    resendInSeconds: `{{no}}秒后重新发送`,

    createAccount: '创建账户',
    letSignYouUp: '让我们帮你注册',
    pleaseProvideYourFirstnameAndLastnameForSigningUp: '请提供您的名字和姓氏以进行注册',
    gender: '性别',
    contactNo: '联系号码',
    sendCode: '发送验证码',
    signUp: '注册',
    accountLogin: '账户登录',

    newUserSignUpHere: '注册',
    forgotPassword: '忘记密码?',
    clickHere: '点击这里',

    resetPassword: '重置密码',
    newPassword: '新密码',
    pleaseEnterYourNewPasswordBelow: '请输入新密码',

    verifyCode: '验证码',
    enterReceiveVerificationCodeBelow: '在下方输入接收验证码',
    submit: '提交',

    verifyExistingUser: '验证现有用户',
    pleaseEnterYourContactToVerifyExistingUser: '请输入您的联系方式以验证现有用户',
};